<template>
  <v-dialog v-model="isOpen" :max-width="!hasMenu || hasNotificationConfigAuthority ? 1024 : 720" persistent close-delay="500">
    <v-card>
      <v-card-title primary-title class="primary white--text">
        Fazer upload de arquivos
      </v-card-title>

      <v-card-text class="pt-6">
        <GenericFileInput ref="inputFileMobile" @update="uploadFileInput" @verifyNotificationFields="verifyNotificationFields" :resetFileInput="resetFileInput" @resetCompleted="resetFileInput = false"/>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer/>
        <v-btn depressed class="primary" :disabled="!this.selectedFiles.length || !isNotificationConfigValid" @close="uploadConfirm" @click="uploadConfirm">Enviar</v-btn>
        <v-btn depressed class="tertiary" @click="close">fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GenericFileInput from '@/components/generic-file-input/index.vue';
import { isValidFileSize } from '@/utils/validations';
import store from '@/common/store';

export default {
  name: 'FilePickerMobile',
  components: { GenericFileInput },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    hasMenu: false,
    isOpen: false,
    selectedFiles: [],
    isNotificationConfigValid: true,
    hasNotificationConfigAuthority: false,
    notificationConfig: null,
    usersWithAccessPermission: [],
    profiles: [],
    resetFileInput: false,
  }),
  methods: {
    uploadFileInput(file) {
      this.selectedFiles = file;
    },
    uploadConfirm() {
      const hasInvalidFiles = this.checkFileWithInvalidSizes(this.selectedFiles);

      if (hasInvalidFiles.length > 0) {
        this.$emit('error', hasInvalidFiles);

        return;
      }

      this.isOpen = false;
      this.loadUserIdsSelectedsToNotify();
      this.loadProfileIdsSelectedsToNotify();
      this.$emit('upload', { files: this.selectedFiles, notificationConfig: this.notificationConfig });
    },
    close() {
      this.isOpen = false;
      this.selectedFiles = [];
      if (this.$refs.inputFileMobile) {
        this.$refs.inputFileMobile.$refs.files.reset();
        this.$refs.inputFileMobile.clearNotificationFields();
      }
      this.$emit('close');
    },
    verifyNotificationFields(paramsNotification) {
      this.hasMenu = paramsNotification.hasMenu;

      if (paramsNotification.isSendingNotification) {
        this.isNotificationConfigValid = false;
        this.notificationConfig = null;
        if (!this.isEmptyNotificationFields(paramsNotification.notificationConfig)) {
          this.isNotificationConfigValid = true;
          this.notificationConfig = paramsNotification.notificationConfig;
          this.profiles = paramsNotification.profiles;
          this.usersWithAccessPermission = paramsNotification.usersWithAccessPermission;
        }
      } else {
        this.isNotificationConfigValid = true;
      }
    },
    isEmptyNotificationFields(notificationConfig) {
      const emptyFields = [];
      if (this.hasMenu && notificationConfig.driveDefaultTemplateId === null) {
        emptyFields.push('Template Padrão');
      }
      if (notificationConfig.driveEmailTemplateId === null) {
        emptyFields.push('Template de E-mail');
      }
      if (this.hasMenu && (!notificationConfig.selectedUsers || (notificationConfig.selectedUsers && notificationConfig.selectedUsers.length === 0
        && (!notificationConfig.selectedProfiles || (notificationConfig.selectedProfiles && notificationConfig.selectedProfiles.length === 0))))) {
        emptyFields.push('Usuários');
      }
      if (!this.hasMenu && notificationConfig.customEmails.trim().length === 0) {
        emptyFields.push('E-mails dos Usuários');
      }
      if (!notificationConfig.deliveryChannels || (notificationConfig.deliveryChannels && notificationConfig.deliveryChannels.length === 0)) {
        emptyFields.push('Tipos de Notificações');
      }

      if (emptyFields.length > 0) {
        return true;
      }
      return false;
    },
    loadUserIdsSelectedsToNotify() {
      const usersFiltered = [];
      if (this.notificationConfig && this.notificationConfig.selectedUsers) {
        this.notificationConfig.selectedUsers.forEach((value) => {
          usersFiltered.push(this.usersWithAccessPermission[value].userId);
        });
        this.notificationConfig.selectedUsers = usersFiltered;
      }
    },
    loadProfileIdsSelectedsToNotify() {
      const profilesFiltered = [];
      if (this.notificationConfig && this.notificationConfig.selectedProfiles) {
        this.notificationConfig.selectedProfiles.forEach((value) => {
          profilesFiltered.push(this.profiles[value].id);
        });
        this.notificationConfig.selectedProfiles = profilesFiltered;
      }
    },
    checkFileWithInvalidSizes(files) {
      const invalidFiles = [];

      files.forEach((file) => {
        if (!isValidFileSize(file.body)) {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length === 0) return [];

      return invalidFiles;
    },
  },
  beforeCreate() {
    this.hasNotificationConfigAuthority = store.getHasNotificationConfigAuthority();
  },
  watch: {
    open(newValue) {
      this.isOpen = newValue;
      this.hasNotificationConfigAuthority = store.getHasNotificationConfigAuthority();
    },
    isOpen(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.resetFileInput = true;
      }
    },
  },
};
</script>

<style lang="scss">

#fab-upload {
  display: none;
}
</style>
